import { useLayoutEffect } from 'react'
import { getFrameworkVar } from '../utils/Sparky'

const useFullscreenPage = () => {
  useLayoutEffect(() => {
    const ftNewLeftNav = getFrameworkVar('use_new_left_nav')
    const appClassList = document.querySelector(ftNewLeftNav ? '.sparky-left-nav' : '.sparky-app')?.classList
    if (ftNewLeftNav) {
      appClassList?.remove('spf-z-[1000]')
    }
    else {
      appClassList?.add('sparky-app-bar-z-0')
    }
    return () => {
      if (ftNewLeftNav) {
        appClassList?.add('spf-z-[1000]')
      }
      else {
        appClassList?.remove('sparky-app-bar-z-0')
      }
    }
  }, [])
}

export default useFullscreenPage
